export default "__VITE_ASSET__ef421d29__"